import { FaPalette, FaEnvelope, FaMagic } from 'react-icons/fa';

export const VALUE_DAY = {
  YEAR: 365,
  MONTH: 30,
  DAY: 1,
};

export const ENUM_CONFIGURATION_CERTIFICATES = {
  XSD: 'XSD',
  CERTIFICADOS: 'CERTIFICADOS',
  BUILDER: 'CERTIFICATE BUILDER',
};

export const tabs = [
  { name: 'CERTIFICADOS', icon: <FaEnvelope /> },
  { name: 'XSD', icon: <FaPalette /> },
  { name: 'CERTIFICATE BUILDER', icon: <FaMagic /> },
];
